import { getSpamChatsV2 } from './getSpamChatsV2';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';
import { EChatListTrigger } from '../../utils/logging/publicApiDiagnostics';

export const getSpamListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestampSpam = chatList.isFirstLoad
    ? undefined
    : chatList.chats.length
      ? getLastTimeStamp(chatList.chats)
      : state.chatList.timestampSpam;

  const trigger = chatList.isFirstLoad ? EChatListTrigger.FirstLoad : EChatListTrigger.NextPage;

  dispatch(getSpamChatsV2({ timestampSpam }, trigger));
};
